import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';

import { SectionMetrics } from './SectionMetrics';

export const Statistic = (props: RouteComponentProps) => (
  <Switch>
    <Route path={`${props.match.path}/section-metrics`} component={SectionMetrics} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/screens/statistic/Statistic.tsx